import { i18n } from "@/plugins/i18n";

export class Expense {
  columns = [];
  id = "id";

  fillAbles = [
    ["title", i18n.t("title"), true],
    ["expenseType.name", i18n.t("expenseType"), true],
    ["safeboxId", i18n.t("safeboxId"), true, false],
    ["mcPrice", i18n.t("mcPrice"), true, false],
    ["qty", i18n.t("qty"), true, false],
    ["mcTotalPrice", i18n.t("mcTotalPrice"), true],
    ["date", i18n.t("date"), true],
    ["note", i18n.t("note"), true],
    ["attachment", i18n.t("attachment"), true],
    ["controls", i18n.t("controls"), false],
  ];

  getColumns() {
    this.columns = [
      {
        label: i18n.t("id"),
        name: "id",
        sort: false,
        visibility:
          process.env.VUE_APP_PROJECT_NAME === "MassHills" ? false : true,
        uniqueId: true,
      },
    ];
    this.fillAbles.map((e) => {
      this.columns.push({
        name: e[0],
        label: e[1],
        sort: e[2],
        visibility: e[3] ?? true,
      });
    });
    return this.columns;
  }
}
